var map = {
	"./admin block.webp": 51794,
	"./automobile.webp": 30489,
	"./bsc.webp": 60520,
	"./campus life@KEC.webp": 66208,
	"./chemical.webp": 45684,
	"./civil.webp": 78155,
	"./convention.webp": 74635,
	"./csd.webp": 35958,
	"./ece.webp": 49839,
	"./eee.webp": 68961,
	"./eie.webp": 83277,
	"./enthusia 2026.webp": 4293,
	"./food court.webp": 76339,
	"./food technology.webp": 10430,
	"./hackathon.webp": 18037,
	"./itpark.webp": 44193,
	"./kcc.webp": 88787,
	"./kec.webp": 24933,
	"./kvitt.webp": 83232,
	"./maharaja auditorium.webp": 43692,
	"./mba.webp": 48650,
	"./mechanical.webp": 62827,
	"./mechatronics.webp": 63476,
	"./sports.webp": 61447,
	"./swaram2026.webp": 11625,
	"./vinayagartemple.webp": 83225,
	"./volleyball.webp": 79472,
	"./wifi_campus.webp": 8635
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93407;